import { DateTime, WeekdayNumbers } from 'luxon';
import React from 'react';

import { LocalizedTime } from '../../helpers/dates';
import { OpenCloseHoursWeekdays } from './open-close-hours-weekdays.interface';

interface OpeningHoursFullProps {
  openingHoursArray: OpenCloseHoursWeekdays[];
  timezone: string;
  node_locale: string;
}

export const OpeningHoursFull = ({
  openingHoursArray,
  node_locale,
  timezone,
}: OpeningHoursFullProps) => {
  const luxonWeekdayFormatString = 'cccc';
  const titleCaseString = (string: string): string => {
    return string
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };
  const temporaryDateTime = DateTime.now()
    .setLocale(node_locale)
    .setZone(timezone);

  return (
    <ul>
      {openingHoursArray?.map((hours, index) => (
        <li key={`${hours.weekDays[0]}-${index}`}>
          {titleCaseString(
            temporaryDateTime
              .set({ weekday: hours.weekDays[0] as WeekdayNumbers }) // Casting here
              .toFormat(luxonWeekdayFormatString),
          )}
          : {LocalizedTime(hours.open, node_locale)} -{' '}
          {LocalizedTime(hours.close, node_locale)}{' '}
        </li>
      ))}
    </ul>
  );
};
